var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checkout-circl",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:currentColor;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "h_checkmark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Regular-M"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.8,116.7c2,0,3.9-1,4.9-2.7l46.1-72.7c0.8-1.1,1.2-2.3,1.2-3.6c0.1-2.3-1.6-4.3-3.9-4.4c-0.2,0-0.4,0-0.5,0 c-2,0-3,0.6-4.2,2.5l-43.8,69.9L41.8,75.8c-0.9-1.5-2.5-2.4-4.2-2.4c-2.4-0.1-4.5,1.7-4.7,4.2c0,0.1,0,0.3,0,0.4 c0.1,1.3,0.6,2.6,1.4,3.6l25.3,32.3C61.2,115.8,62.7,116.7,64.8,116.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHCheckmark);
export default __webpack_public_path__ + "static/media/h_checkmark.9eac9ef802b6ea5fe9f23c0a0e048cf3.svg";
export { ForwardRef as ReactComponent };